import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Apollo, gql } from 'apollo-angular';
import { ApplicationComponent, Calendar, CalendarApplicationComponent, CalendarApplicationComponentUpdate, CalendarEventCategory, CalendarInput, CalendarRegistrationForm, CoreLibService, Group, Location, LocationInput, Mutation, Query, LinkOpenMode  } from 'core-lib';
import  moment from 'moment';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { FileUpload } from 'primeng/fileupload';
import { Menu } from 'primeng/menu';
import { environment } from 'projects/appointment-module/src/environments/environment';
import { AttendeesExportForm } from '../attendees-export-form/attendees-export-form.component';
import { AppointmentRegistrationFormComponent } from './../appointment-registration-form/appointment-registration-form.component';
import { Message } from 'primeng/message';

declare var google;

enum CALENDAR_ACCESS_TYPE {
  GROUP = 'Group',
  ROLE = 'Role'
}

@Component({
    selector: 'lib-appointment-configuration',
    templateUrl: './appointment-configuration.component.html',
    styleUrls: ['./appointment-configuration.component.scss'],
    standalone: false
})
export class AppointmentConfigurationComponent implements OnInit {

  @ViewChild('calendarMenu') calendarMenu: Menu;
  @ViewChild('calendarICSFileUpload') calendarICSFileUpload: FileUpload;
  @ViewChild('calendarXLSXFileUpload') calendarXLSXFileUpload: FileUpload;

  public static PERIOD_CONFIGURATIONS = [
    { label: $localize`:@@appointment-configuration.application-configuration-page-range.1D:Current day`, value: '1D', start: moment().startOf('day').toDate(), end: moment().endOf('day').toDate(), page: moment.duration(1, 'day'), format: 'shortDate' },
    { label: $localize`:@@appointment-configuration.application-configuration-page-range.2D:Next day`, value: '2D', start: moment().startOf('day').toDate(), end: moment().add(1, 'day').endOf('day').toDate(), page: moment.duration(1, 'day'), format: 'shortDate' },
    { label: $localize`:@@appointment-configuration.application-configuration-page-range.1W:Current week`, value: '1W', start: moment().startOf('isoWeek').toDate(), end: moment().endOf('isoWeek').toDate(), page: moment.duration(1, 'week'), format: 'shortDate' },
    { label: $localize`:@@appointment-configuration.application-configuration-page-range.2W:Next week`, value: '2W', start: moment().startOf('isoWeek').toDate(), end: moment().add(1, 'week').endOf('isoWeek').toDate(), page: moment.duration(1, 'week'), format: 'shortDate' },
    { label: $localize`:@@appointment-configuration.application-configuration-page-range.1M:Current month`, value: '1M', start: moment().startOf('month').toDate(), end: moment().endOf('month').toDate(), page: moment.duration(1, 'month'), format: 'MMM yyyy' },
    { label: $localize`:@@appointment-configuration.application-configuration-page-range.2M:Next month`, value: '2M', start: moment().startOf('month').toDate(), end: moment().add(1, 'month').endOf('month').toDate(), page: moment.duration(1, 'month'), format: 'MMM yyyy' },
    { label: $localize`:@@appointment-configuration.application-configuration-page-range.3M:Next 2 months`, value: '3M', start: moment().startOf('month').toDate(), end: moment().add(2, 'month').endOf('month').toDate(), page: moment.duration(1, 'month'), format: 'MMM yyyy' },
    { label: $localize`:@@appointment-configuration.application-configuration-page-range.4M:Next 3 months`, value: '4M', start: moment().startOf('month').toDate(), end: moment().add(3, 'month').endOf('month').toDate(), page: moment.duration(1, 'month'), format: 'MMM yyyy' },
    { label: $localize`:@@appointment-configuration.application-configuration-page-range.7M:Next 6 months`, value: '7M', start: moment().startOf('month').toDate(), end: moment().add(6, 'month').endOf('month').toDate(), page: moment.duration(1, 'month'), format: 'MMM yyyy' },
    { label: $localize`:@@appointment-configuration.application-configuration-page-range.1Q:Current quarter`, value: '1Q', start: moment().startOf('quarter').toDate(), end: moment().endOf('quarter').toDate(), page: moment.duration(1, 'quarter'), format: 'MMM yyyy' },
    { label: $localize`:@@appointment-configuration.application-configuration-page-range.2Q:Next quarter`, value: '2Q', start: moment().startOf('quarter').toDate(), end: moment().add(1, 'quarter').endOf('quarter').toDate(), page: moment.duration(1, 'quarter'), format: 'MMM yyyy' },
    { label: $localize`:@@appointment-configuration.application-configuration-page-range.1Y:Current year`, value: '1Y', start: moment().startOf('year').toDate(), end: moment().endOf('year').toDate(), page: moment.duration(1, 'year'), format: 'MMM yyyy' }];

  public static PERIOD_BY_VALUE(value: string): any {
    return AppointmentConfigurationComponent.PERIOD_CONFIGURATIONS.find((config) => config.value === value);
  }

  editLocationDialogHeader = $localize`:@@appointment-configuration.location.edit.title:Edit location`;
  addLocationDialogHeader = $localize`:@@appointment-configuration.location.add.title:Add location`;
  editCalendarDialogHeader = $localize`:@@appointment-configuration.calendar.edit.title:Edit calendar`;
  addCalendarDialogHeader = $localize`:@@appointment-configuration.calendar.add.title:Add calendar`;
  _embedUrl: string;
  calendars: Calendar[] = [];
  locations: Location[] = [];
  registrationForms: CalendarRegistrationForm[] = [];
  searchedLocations: Location[] = [];
  usedCalendarIds: { string?: string } = {};
  dialogControl = {
    context: null,
    showLocationEditDialog: false,
    showCalendarEditDialog: false,
    calendarEditDialog: {
      visible: false,
      accessType: CALENDAR_ACCESS_TYPE.GROUP
    },
    categoryInEdit: null,
    showDeleteCalendarDialog: false
  };
  addCalendarButtonItems: MenuItem[] = [{ label: $localize`:@@appointment-configuration.calendar.button-ical.add:Add iCal feed`, icon: 'far fa-plus', command: () => { this.onEditICalCalendar(); } }];

  applicationComponent: ApplicationComponent;
  pageItems: any[] = AppointmentConfigurationComponent.PERIOD_CONFIGURATIONS;
  apiURL = environment.apiURL;

  groups: Group[];
  accessTypes: any[] = [];


  set embedUrl(url: string) {
    this._embedUrl = url;
  }

  get embedUrl(): string {
    let url = this._embedUrl;
    if (url == null){
      return null;
    }

    let parameterSeperator= "?";
    const values =this.embedCodeForm.value;
    if (values.filterText && values.filterText!==''){
      url+= `${parameterSeperator}filterText=${values.filterText}`;
      parameterSeperator = "&";
    }
    if (values.viewMode && values.viewMode!=='list'){
      url+= `${parameterSeperator}viewMode=${values.viewMode}`;
      parameterSeperator = "&";
    }
    if (values.calendarIds){
      url+= `${parameterSeperator}calendarIds=${values.calendarIds.join(',')}`;
      parameterSeperator = "&";
    }

    return url;
  }

  menuConfiguration = {
    calendar: null,
    itemMenuItems: [],
    openMenuForItem: (event, calendar: Calendar) => {
      this.menuConfiguration.calendar = calendar;
      this.menuConfiguration.itemMenuItems = [];
      if (this.coreLibService.hasAnyClaims(['component_update'])) {
        this.menuConfiguration.itemMenuItems.push({
          label: $localize`:@@appointment-configuration.calendar.context-menu-edit:Edit calendar`, icon: 'far fa-pen', command: () => {
            this.onEditCalendar(this.menuConfiguration.calendar);
          }
        },
          {
            label: $localize`:@@appointment-configuration.calendar.context-menu-download-ics:Download ICS`, icon: 'far fa-arrow-down-to-bracket', command: () => {
              this.onDownloadCalendar(this.menuConfiguration.calendar);
            }
          },
          {
            label: $localize`:@@appointment-configuration.calendar.context-feed-url:Copy iCal Feed`, icon: 'far fa-copy', command: () => {
              this.onCopyICalFeedToClipboard(this.menuConfiguration.calendar);
            }
          },
          {
            label: $localize`:@@appointment-configuration.calendar.context-calender-id:Copy calendar ID`, icon: 'far fa-copy', command: () => {
              this.onCopyCalenderIDToClipboard(this.menuConfiguration.calendar);
            }
          },
          {
            label: $localize`:@@appointment-configuration.calendar.context-menu-delete:Delete calendar`, icon: 'far fa-trash', command: () => {
              this.onOpenDeleteCalendarDialog(this.menuConfiguration.calendar);
            }
          }
        );
        if (calendar.iCalUrl != null) {
          this.menuConfiguration.itemMenuItems.push({
            label: $localize`:@@appointment-configuration.calendar.context-menu-synccal:Sync calendar`, icon: 'far fa-sync', command: () => {
              this.syncCalendarFromSource(this.menuConfiguration.calendar);
            }
          });
        } else {
          this.menuConfiguration.itemMenuItems.push({
            label: $localize`:@@appointment-configuration.calendar.context-menu-ExportAttendees:Export attendees`, icon: 'far fa-user', command: () => {
              this.onExportAttendeesToExcel(this.menuConfiguration.calendar);
            }
          });
          this.menuConfiguration.itemMenuItems.push({
            label: $localize`:@@appointment-configuration.calendar.context-menu-uploadICS:Import ICS`, icon: 'far fa-arrow-up-from-bracket', command: () => {
              this.calendarICSFileUpload.basicFileInput.nativeElement.click();
            }
          });
          this.menuConfiguration.itemMenuItems.push({
            label: $localize`:@@appointment-configuration.calendar.context-menu-uploadExcel:Import Excel`, icon: 'far fa-file-excel', command: () => {
              this.calendarXLSXFileUpload.basicFileInput.nativeElement.click();
            }
          });
        }
      };
      this.calendarMenu.toggle(event);
    }
  }


  CALENDAR_PROPERTIES = ` id
  title
  color
  readerRoles{
    enumKey
    enumId
    value
  }
  writerRoles{
    enumKey
    enumId
    value
  }
  readerGroups{
    name
    id
  }
  writerGroups{
    name
    id
  }
  categories{
    id
    title
    color
  }
  iCalUrl
  iCalLastSynced
  hints`;

  IMPORT_ICS_FILE = gql`
    mutation importICSFile($calendarId:ID!, $file:UploadId!){
      importICSFile(calendarId:$calendarId, file: $file)
    }`;

  IMPORT_XLSX_FILE = gql`
    mutation importCalendarExcelFile($calendarId:ID!, $file:UploadId!){
      importCalendarExcelFile(calendarId:$calendarId, file: $file)
    }`;

  MUTATION_ADD_LOCATION = gql`
  mutation createLocation($data : LocationInput){
    createLocation(data : $data){
      id
      title
      postalCode
      street
      city
      geoLat
      geoLng
  }}`;

  MUTATION_UPDATE_LOCATION = gql`
  mutation updateLocation($locationId : ID!,$location : LocationInput){
    updateLocation(locationId:$locationId, location : $location){
      id
      title
      postalCode
      street
      city
      geoLat
      geoLng
  }}`;

  MUTATION_DELETE_LOCATION = gql`
  mutation deleteLocation($locationId : ID!){
    deleteLocation(locationId : $locationId)
  }`;

  MUTATION_DELETE_REGISTRATION_FORM = gql`
  mutation deleteCalendarRegistrationForm($id : ID!){
    deleteCalendarRegistrationForm(id : $id)
  }`;

  MUTATION_DELETE_CALENDAR = gql`
  mutation deleteCalendar($calendarId : ID!){
    deleteCalendar(calendarId : $calendarId)
  }`;

  MUTATION_CLEAR_CALENDAR = gql`
  mutation clearCalendar($calendarId : ID!){
    clearCalendar(calendarId : $calendarId)
  }`;

  MUTATION_UPDATE_APPLICATION_COMPONENT = gql`
  mutation updateCalendarApplicationComponent($id:ID!,$update:CalendarApplicationComponentUpdate!) {
    updateCalendarApplicationComponent(id : $id,update:$update){
       config
    }
  }`;

  QUERY_CALENDAR_FEED = gql`
  query getCalendarICalFeedUrl($calendarId : ID!){
    getCalendarICalFeedUrl(calendarId : $calendarId)
  }`;

  QUER_COMPONENT_FEED = gql`
  query getCalendarComponentICalFeedURL($componentId : ID!){
    getCalendarComponentICalFeedURL(componentId : $componentId)
  }`;

  INIT_QUERY = gql`
  query combinedInitQuery($componentId:ID!){
    listCalendarByComponentId(componentId: $componentId) {
      id
    }
    getCalendarEmbedUrl(componentId: $componentId)
    applicationComponent(id:$componentId){
      applicationType
      ... on CalendarApplicationComponent{
        config
      }
    }
    getCalendarRegistrationForms{
      name
      id
      usedInEventsCount
    }
    listCalendars {
      ${this.CALENDAR_PROPERTIES}
    }
    listLocations{
      id
      title
      postalCode
      street
      city
      geoLat
      geoLng
    }
  }`;

  MUTATION_ADD_CALENDAR = gql`
  mutation createCalendar($data : CalendarInput!){
    createCalendar(data : $data){
      ${this.CALENDAR_PROPERTIES}
  }}`;

  MUTATION_ADD_ICALENDAR = gql`
  mutation createCalendarFromICal($data : CalendarInput!,$url : Url!){
    createCalendarFromICal(data : $data, url: $url){
      ${this.CALENDAR_PROPERTIES}
  }}`;

  SYNC_ICAL_CALENDAR_QUERY = gql`
  mutation refreshCalendarFromICal($calendarId:ID!){
    refreshCalendarFromICal(calendarId : $calendarId){
      ${this.CALENDAR_PROPERTIES}
  }}`;

  MUTATION_UPDATE_CALENDAR = gql`
  mutation updateCalendar($calendarId : ID!,$data : CalendarInput!){
    updateCalendar(calendarId:$calendarId, data : $data){
      ${this.CALENDAR_PROPERTIES}
  }}`;

  MUTATION_MODIFY_CATEGORY = gql`
  mutation createOrUpdateCalendarEventCategory($calendarId : ID!, $input : CalendarEventCategoryInput!){
    createOrUpdateCalendarEventCategory(calendarId: $calendarId, input : $input){
      id
      title
      color
  }}`;

  MUTATION_UPDATE_EMBED_CODE = gql`
  mutation updateCalendarEmbedUrl($componentId: ID!){
    updateCalendarEmbedUrl(componentId: $componentId)
  }`;


  MUTATION_DELETE_CATEGORY = gql`
  mutation deleteCalendarEventCategory($calendarId : ID!, $categoryId : ID!){
    deleteCalendarEventCategory(calendarId : $calendarId, categoryId : $categoryId) {
      id
      categories {
        title
        color
        id
      }
    }
  }`;

  LOAD_CALENDAR = gql`
  query getCalender($calendarId: ID!){
    getCalender(calendarId: $calendarId) {
      ${this.CALENDAR_PROPERTIES}
    }
  }`;

  embedCodeForm: UntypedFormGroup;
  applicationConfigurationForm: UntypedFormGroup;



  constructor(private apollo: Apollo, public coreLibService: CoreLibService, @Inject('component') public component: string, private http: HttpClient,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ref: ChangeDetectorRef,
    private dialogService: DialogService,
  ) { }


  /**
   * deletes calendar
   * @param calendar
   */
  onDeleteCalendar(calendar: Calendar): void {
    this.apollo.query<Mutation>({
      query: this.MUTATION_DELETE_CALENDAR,
      variables: { calendarId: calendar.id }
    }).subscribe((result) => {
      if (!result.error) {
        const message = $localize`:@@appointment-configuration.calendar.delete-ok:Calendar deleted`;
        this.messageService.add({ severity: 'success', detail: message });
        const index = this.calendars.indexOf(calendar);
        this.calendars.splice(index, 1);
        this.calendars = [...this.calendars];
        this.dialogControl.showDeleteCalendarDialog = false;
      }
    });
  }

  /**
   * clears calendar
   * @param calendar
   */
  onClearCalendar(calendar: Calendar): void {
    this.apollo.query<Mutation>({
      query: this.MUTATION_CLEAR_CALENDAR,
      variables: { calendarId: calendar.id }
    }).subscribe((result) => {
      if (!result.error) {
        const message = $localize`:@@appointment-configuration.calendar.clear-ok:Removed all events in this calendar.`;
        this.messageService.add({ severity: 'success', detail: message });
        this.dialogControl.showDeleteCalendarDialog = false;
      }
    });
  }

  onOpenDeleteCalendarDialog(calendar: Calendar): void {
    this.dialogControl.context = { calendar: calendar };
    this.dialogControl.showDeleteCalendarDialog = true;
  }

  onAddOrUpdateLocation(location: Location): void {
    if (this.dialogControl.context.id) {
      this.onLocationChanged(location);
    } else {
      this.onAddLocation(location);
    }
  }
  /**
   * on change location
   * @param location
   */
  onLocationChanged(location: Location): void {
    const locationInput = { title: location.title, geoLat: location.geoLat, geoLng: location.geoLng, street: location.street, city: location.city, postalCode: location.postalCode } as LocationInput;
    this.apollo.mutate<Mutation>({
      mutation: this.MUTATION_UPDATE_LOCATION,
      variables: {
        location: locationInput, locationId: location.id
      }
    }).subscribe((result) => {
      if (!result.errors) {
        const message = $localize`:@@appointment-configuration.location.update-ok:Location updated`;
        this.messageService.add({ severity: 'success', detail: message });
        const index = this.locations.findIndex((loc) => loc.id === location.id);
        this.locations[index] = location;
        this.locations = [...this.locations];
        this.dialogControl.context = null;
        this.dialogControl.showLocationEditDialog = false;
      }
    });
  }

  /**
   * adds new calendar
   */
  onEditICalCalendar(): void {
    var calendar = { color: '#fff' } as Calendar;
    this.dialogControl.context = { calendar: { ...calendar }, url: null };
    this.dialogControl.calendarEditDialog.visible = true;
    this.dialogControl.calendarEditDialog.accessType = calendar.readerRoles?.length > 0 || calendar.writerRoles?.length > 0 ? CALENDAR_ACCESS_TYPE.ROLE : CALENDAR_ACCESS_TYPE.GROUP;
  }


  usesRoleBasedAccessControl(calendar: Calendar): boolean {
    if (calendar.readerRoles != null && calendar.writerRoles.length > 0) {
      return true;
    }
    if (calendar.readerRoles != null && calendar.writerRoles.length > 0) {
      return true;
    }
    return false;
  }

  /**
   * adds new calendar
   */
  onAddCalendar(): void {
    var calendar = { color: '#fff', categories: [], writerRoles: [], readerRoles: [], readerGroups: [], writerGroups: [] } as Calendar;
    this.dialogControl.context = { calendar: { ...calendar }, used: true };
    this.dialogControl.showCalendarEditDialog = true;
    this.dialogControl.calendarEditDialog.accessType = CALENDAR_ACCESS_TYPE.GROUP;
    this.setAccessTypes();
  }
  /**
  * edit calendar
  * @param calendar
  */
  onEditCalendar(calendar: Calendar): void {
    this.dialogControl.context = { calendar: { ...calendar }, used: this.usedCalendarIds[calendar.id] != null };
    this.dialogControl.showCalendarEditDialog = true;
    this.dialogControl.calendarEditDialog.accessType = calendar.readerRoles?.length > 0 || calendar.writerRoles?.length > 0 ? CALENDAR_ACCESS_TYPE.ROLE : CALENDAR_ACCESS_TYPE.GROUP;
    this.setAccessTypes();
  }


  /**
   * on add location
   */
  onOpenLocationDialog(): void {
    var location = { title: '' } as Location;
    this.dialogControl.context = location;
    this.dialogControl.showLocationEditDialog = true;
  }
  /**
   * edit location
   * @param location
   */
  onEditLocation(location: Location): void {
    this.dialogControl.context = { ...location };
    this.dialogControl.showLocationEditDialog = true;
  }
  /**
   * deletes location
   * @param location
   */
  onDeleteLocation(location: Location): void {
    this.confirmationService.confirm({
      header: $localize`:@@appointment-configuration.location.delete.header:Delete location`,
      message: $localize`:@@appointment-configuration.location.delete.message:Do you really want to delete location ${location.title} ?`,
      acceptLabel: $localize`:@@appointment-configuration.location.delete.buttons.yes:Delete`,
      rejectLabel: $localize`:@@appointment-configuration.location.delete.buttons.cancel:Cancel`,
      acceptIcon: 'none',
      rejectIcon: 'none',
      defaultFocus: 'none',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary',
      accept: () => {
        this.apollo.query<Mutation>({
          query: this.MUTATION_DELETE_LOCATION,
          variables: { locationId: location.id }
        }).subscribe((result) => {
          if (!result.error) {
            const message = $localize`:@@appointment-configuration.location.delete-ok:Location deleted`;
            this.messageService.add({ severity: 'success', detail: message });
            const index = this.locations.indexOf(location);
            this.locations.splice(index, 1);
            this.locations = [...this.locations];
          }
        });
      }
    });
  }

  /**
   * add location
   * @param event
   */
  onAddLocation(event: Location): void {
    const locationInput = { title: event.title, geoLat: event.geoLat, geoLng: event.geoLng, street: event.street, city: event.city, postalCode: event.postalCode } as LocationInput;
    this.apollo.mutate<Mutation>({
      mutation: this.MUTATION_ADD_LOCATION,
      variables: {
        data: locationInput
      }
    }).subscribe((result) => {
      if (!result.errors) {
        this.locations = [...this.locations, result.data.createLocation];
        this.messageService.add({ severity: 'success', summary: $localize`:@@appointment-configuration.location.added:Added location` } );
        this.dialogControl.showLocationEditDialog = false;
        this.dialogControl.context = {};
      }
    });
  }

  onSearchPlaceSelected(event: Location): void {
    const service = new google.maps.places.PlacesService(document.createElement('div'));
    service.getDetails(
      {
        placeId: event['placeId'],
        fields: ['address_components']
      }, (result) => {
        if (result && result.address_components && result.address_components) {
          const addressComponent = result.address_components;
          let tempStreeNumber = "";
          for (const component of addressComponent) {
            if (component.types.includes('postal_code')) {
              event.postalCode = component.long_name;
            } else if (component.types.includes('route')) {
              event.street = component.long_name;
            } else if (component.types.includes('locality')) {
              event.city = component.long_name;
            }
            else if (component.types.includes('street_number')) {
              tempStreeNumber = component.long_name;
            }
          }
          if (event.street) {
            event.street = `${event.street} ${tempStreeNumber}`;
          }
        }
        this.ref.detectChanges();
      }
    );
  }

  searchPlaces(event): void {
    const query = event.query;
    const request = {
      query: query
    };

    const service = new google.maps.places.PlacesService(document.createElement('div'));
    service.textSearch(request, (results) => {
      const temp = results.map((place) => {
        const ptemp = { title: place.name, geoLat: place.geometry.location.lat(), geoLng: place.geometry.location.lng() } as Location;
        ptemp['placeId'] = place.place_id;
        ptemp['address'] = place.formatted_address;
        return ptemp;
      });
      this.searchedLocations = [...temp];
      this.ref.detectChanges();
    });
  }

  loadCalendarData() {
    this.apollo.query<Query>({
      query: this.INIT_QUERY, variables: {
        componentId: this.component
      }
    }).subscribe((result) => {
      this.calendars = result.data.listCalendars;
      this.locations = result.data.listLocations;
      this.applicationComponent = result.data.applicationComponent;
      this.registrationForms = result.data.getCalendarRegistrationForms;
      result.data.listCalendarByComponentId.forEach((calendar) => {
        this.usedCalendarIds[calendar.id] = calendar.id;
      });
      if (result.data.getCalendarEmbedUrl) {
        this.embedUrl = result.data.getCalendarEmbedUrl;
      }

       const applicationComponent: CalendarApplicationComponent = result.data.applicationComponent;
      if (applicationComponent) {
        const config = applicationComponent.config;
        let period = config?.period_shown;
        if (period == null) {
          period = '3M';
        }
        this.applicationConfigurationForm.patchValue({ "period_shown": period });
      }
    });
  }

  ngOnInit(): void {
    this.loadCalendarData();
    this.embedCodeForm = new UntypedFormGroup({
      "filterText": new UntypedFormControl(null),
      "viewMode": new UntypedFormControl('list'),
      "calendarIds": new UntypedFormControl([])
    });

    this.applicationConfigurationForm = new UntypedFormGroup({
      "period_shown": new UntypedFormControl('3M'),
    });

    this.coreLibService.getGroups().subscribe((groups) => {
      this.groups = groups;
    });
  }

  /**
   * creates or updates embed code
   */
  onUpdateCalendarEmbedUrl(): void {
    this.apollo.mutate<Mutation>({
      mutation: this.MUTATION_UPDATE_EMBED_CODE,
      variables: {
        componentId: this.component
      }
    }).subscribe((result) => {
      this.embedUrl = result.data.updateCalendarEmbedUrl
      const message = $localize`:@@appointment-configuration.embed-code.created:The embed code has been generated.`;
      this.messageService.add({ severity: 'success', detail: message });
    });
  }
  /**
   * creates or updates cateogry on backend
   * @param category
   * @param calendar
   */
  onCreateOrUpdateCategory(category: CalendarEventCategory, calendar: Calendar): void {
    this.apollo.mutate<Mutation>({
      mutation: this.MUTATION_MODIFY_CATEGORY,
      variables: {
        calendarId: calendar.id,
        input: category
      }
    }).subscribe((result) => {
      this.apollo.query<Query>({
        query: this.LOAD_CALENDAR, variables: {
          calendarId: calendar.id
        }
      }).subscribe((result) => {
        const updatedCalendar = result.data.getCalender;
        calendar.categories = updatedCalendar.categories;
        this.dialogControl.categoryInEdit = null;
      });
    });
  }

  /**
   * refreshed cats from server
   * @param category
   * @param calendar
   */
  onRefreshCalendarCategories(calendar: Calendar): void {
    this.apollo.query<Query>({
      query: this.LOAD_CALENDAR, variables: {
        calendarId: calendar.id
      }
    }).subscribe((result) => {
      const updatedCalendar = result.data.getCalender;
      calendar.categories = updatedCalendar.categories;
      this.dialogControl.categoryInEdit = null;
    });
  }


  /**
   * Deletes the category
   * @param category
   * @param calendar
   */
  onDeleteCategory(category: CalendarEventCategory, calendar: Calendar): void {
    this.apollo.mutate<Mutation>({
      mutation: this.MUTATION_DELETE_CATEGORY,
      variables: {
        calendarId: calendar.id,
        categoryId: category.id
      }
    }).subscribe((result) => {
      const updatedCalendar = result.data.deleteCalendarEventCategory;
      calendar.categories = updatedCalendar.categories;
      this.dialogControl.categoryInEdit = null;
    });
  }

  /**
   * triggers calendar sync
   * @param calendar
   */
  syncCalendarFromSource(calendar: Calendar): void {

    this.apollo.mutate<Mutation>({
      mutation: this.SYNC_ICAL_CALENDAR_QUERY,
      variables: {
        calendarId: calendar.id
      }
    }).subscribe((result) => {
      if (!result.errors) {
        const icalResult = result.data.refreshCalendarFromICal;
        if (icalResult) {
          calendar.iCalLastSynced = icalResult.iCalLastSynced;
          calendar.hints = icalResult.hints;
        }
        const message = $localize`:@@appointment-configuration.calendar.synced:Calendar synchronized`;
        this.messageService.add({ severity: 'success', detail: message });
      }
    });
  }

  /**
   * @param calendar
   * @param event
   */
  uploadICS(calendar: Calendar, event: any): void {
    const formData = new FormData();
    formData.append("file", event.files[0]);
    this.http.post(`${this.apiURL}/file-api/file-upload`, formData).subscribe((uploadResponse: any) => {
      this.apollo.mutate<Mutation>({
        mutation: this.IMPORT_ICS_FILE,
        variables: {
          calendarId: calendar.id, file: uploadResponse.id
        }
      }).subscribe((result) => {
        this.calendarICSFileUpload.clear();
        if (!result.errors) {
          const message = $localize`:@@appointment-configuration.calendar.ics-import:Successfully imported the ICS file.`;
          this.messageService.add({ severity: 'success', detail: message });
          this.loadCalendarData();
        }
      });
    });

  }

  /**
   * @param calendar
   * @param event
   */
  uploadXLSX(calendar: Calendar, event: any): void {
    const formData = new FormData();
    formData.append("file", event.files[0]);
    this.http.post(`${this.apiURL}/file-api/file-upload`, formData).subscribe((uploadResponse: any) => {
      this.apollo.mutate<Mutation>({
        mutation: this.IMPORT_XLSX_FILE,
        variables: {
          calendarId: calendar.id, file: uploadResponse.id
        }
      }).subscribe((result) => {
        this.calendarXLSXFileUpload.clear();
        if (!result.errors) {
          const message = $localize`:@@appointment-configuration.calendar.xlsx-import:Successfully imported the Excel file.`;
          this.messageService.add({ severity: 'success', detail: message });
        }
      });
    });
  }


  /**
   * on Download Calendar
   */

  onDownloadCalendar(calendar: Calendar): void {
    const url = `${this.apiURL}/file-api/calendar/${calendar.id}/ical-export?access_token=${this.coreLibService.getJWTToken()}`
    window.open(url, '_blank').focus();
  }

  onCopyToClibboardFailed(feedUrlPromise: any): void {
    feedUrlPromise.then((response) => {
      const text = response.data.getCalendarICalFeedUrl;
      const event = new CustomEvent('copy-to-clipboard', { detail: { text: text } });
      window.dispatchEvent(event);
      /**
      * check if embedded in iframe
      */
      if (parent) {
        parent.postMessage({ type: event.type, detail: event.detail }, '*');
      }
    });
  }

  onCopyComponentFeedToClibboardFailed(feedUrlPromise: any): void {
    feedUrlPromise.then((response) => {
      const text = response.data.getCalendarComponentICalFeedURL;
      const event = new CustomEvent('copy-to-clipboard', { detail: { text: text } });
      window.dispatchEvent(event);
      /**
      * check if embedded in iframe
      */
      if (parent) {
        parent.postMessage({ type: event.type, detail: event.detail }, '*');
      }
    });
  }
  onCopyComponentICalFeedToClipboard(): void {
    const feedUrlPromise = this.apollo.query<Query>({
      query: this.QUER_COMPONENT_FEED,
      variables: { componentId: this.component }
    }).toPromise();
    if (typeof ClipboardItem && navigator.clipboard.write) {
      // NOTE: Safari locks down the clipboard API to only work when triggered
      //   by a direct user interaction. You can't use it async in a promise.
      //   But! You can wrap the promise in a ClipboardItem, and give that to
      //   the clipboard API.
      //   Found this on https://developer.apple.com/forums/thread/691873
      const text = new ClipboardItem({
        "text/plain": feedUrlPromise
          .then(response => response.data.getCalendarComponentICalFeedURL)
          .then(text => new Blob([text], { type: "text/plain" }))
      })
      navigator.clipboard.write([text]).then(() => {
        this.messageService.add({ severity: 'success', summary: $localize`:@@appointment-configuration.icalToClipboard:URL copied to clipboard.` });
      }).catch(() => {
        this.onCopyComponentFeedToClibboardFailed(feedUrlPromise);
      })
    }
    else {
      // NOTE: Firefox has support for ClipboardItem and navigator.clipboard.write,
      //   but those are behind `dom.events.asyncClipboard.clipboardItem` preference.
      //   Good news is that other than Safari, Firefox does not care about
      //   Clipboard API being used async in a Promise.
      feedUrlPromise
        .then(response => response.data.getCalendarComponentICalFeedURL)
        .then(text => navigator.clipboard.writeText(text).then(() => {
          this.messageService.add({ severity: 'success', summary: $localize`:@@appointment-configuration.icalToClipboard:URL copied to clipboard.` });
        })).catch(() => {
          this.onCopyComponentFeedToClibboardFailed(feedUrlPromise);
        });
    }
  }


    onCopyCalenderIDToClipboard(calendar: Calendar): void {
      if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(calendar.id).then(() => {
          this.messageService.add({ severity: 'success', summary:  $localize`:@@appointment-configuration.clipboardCalenderID.copyok:Id copied to clipboard.` });
        }).catch(e => {
          // this.messageService.add({ severity: 'error', summary: $localize`:@@filesharecomponent-files.clipboard.error:Error`, detail: e });
        });
      }
      const event = new CustomEvent('copy-to-clipboard', { detail: { text: calendar.id } });
      window.dispatchEvent(event);
    }

  onCopyICalFeedToClipboard(calendar: Calendar): void {
    const feedUrlPromise = this.apollo.query<Query>({
      query: this.QUERY_CALENDAR_FEED,
      variables: { calendarId: calendar.id }
    }).toPromise();
    if (typeof ClipboardItem && navigator.clipboard.write) {
      // NOTE: Safari locks down the clipboard API to only work when triggered
      //   by a direct user interaction. You can't use it async in a promise.
      //   But! You can wrap the promise in a ClipboardItem, and give that to
      //   the clipboard API.
      //   Found this on https://developer.apple.com/forums/thread/691873
      const text = new ClipboardItem({
        "text/plain": feedUrlPromise
          .then(response => response.data.getCalendarICalFeedUrl)
          .then(text => new Blob([text], { type: "text/plain" }))
      })
      navigator.clipboard.write([text]).then(() => {
        this.messageService.add({ severity: 'success', summary: $localize`:@@appointment-configuration.icalToClipboard:URL copied.` });
      }).catch(() => {
        this.onCopyToClibboardFailed(feedUrlPromise);
      })
    }
    else {
      // NOTE: Firefox has support for ClipboardItem and navigator.clipboard.write,
      //   but those are behind `dom.events.asyncClipboard.clipboardItem` preference.
      //   Good news is that other than Safari, Firefox does not care about
      //   Clipboard API being used async in a Promise.
      feedUrlPromise
        .then(response => response.data.getCalendarICalFeedUrl)
        .then(text => navigator.clipboard.writeText(text).then(() => {
          this.messageService.add({ severity: 'success', summary: $localize`:@@appointment-configuration.icalToClipboard:URL copied to clipboard.` });
        })).catch(() => {
          this.onCopyToClibboardFailed(feedUrlPromise);
        });
    }
  }


  /**
   * save appointment configuration
   */
  onSaveApplicationConfigurationConfig(): void {
    const config = this.applicationConfigurationForm.getRawValue();
    const update: CalendarApplicationComponentUpdate = { config: config};
    this.apollo.mutate<Mutation>({
      mutation: this.MUTATION_UPDATE_APPLICATION_COMPONENT,
      variables: {
        id: this.component, update: update
      }
    }).subscribe((result) => {
      if (!result.errors) {
        const message = $localize`:@@appointment-configuration.application-config.saved:Configuration saved`;
        this.messageService.add({ severity: 'success', detail: message });
      }
    });
  }


  /**
   * create new registration form
   */
  onEditRegistrationForm(form: CalendarRegistrationForm): void {
    this.dialogService.open(AppointmentRegistrationFormComponent, {
      header: $localize`:@@appointment-configuration.form-registration.add: Add new form`,
      data: {
        formId: form.id
      },
      height: '90%',
        modal: true,
        draggable: false,
        closable: true,
      focusOnShow: false,
      contentStyle: { display: 'flex' }
    }).onClose.subscribe((result) => {
      if (result) {
        const index = this.registrationForms.findIndex((f) => f.id === form.id);
        this.registrationForms[index] = result;
      }
    });
  }

  /**
   * create new registration form
   */
  onCreateRegistrationForm(): void {
    this.dialogService.open(AppointmentRegistrationFormComponent, {
      header: $localize`:@@appointment-configuration.form-registration.add: Add new form`,
      height: '90%',
      focusOnShow: false,
        modal: true,
        draggable: false,
        closable: true,
      contentStyle: { display: 'flex' }
    }).onClose.subscribe((result) => {
      if (result) {
        this.registrationForms.push(result);
      }
    });
  }

  /**
   * Delete the form
   * @param form
   */
  onDeleteRegistrationForm(form: CalendarRegistrationForm): void {
    this.confirmationService.confirm({
      header: $localize`:@@appointment-configuration.form-registration.delete.header:Delete registration form`,
      message: $localize`:@@appointment-configuration.form-registration.delete.message:Do you really want to delete form ${form.name} ?`,
      acceptLabel: $localize`:@@appointment-configuration.form-registration.delete.buttons.yes:Delete`,
      rejectLabel: $localize`:@@appointment-configuration.form-registration.delete.buttons.cancel:Cancel`,
      acceptIcon: 'none',
      rejectIcon: 'none',
      defaultFocus: 'none',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary',
      accept: () => {
        this.apollo.query<Mutation>({
          query: this.MUTATION_DELETE_REGISTRATION_FORM,
          variables: { id: form.id }
        }).subscribe((result) => {
          if (!result.error) {
            const message = $localize`:@@appointment-configuration.form-registration.delete-ok:Form deleted`;
            this.messageService.add({ severity: 'success', detail: message });
            const index = this.registrationForms.indexOf(form);
            this.registrationForms.splice(index, 1);
            this.registrationForms = [...this.registrationForms];
          }
        });
      }
    });
  }

  get selectedLocation() {
    return this.dialogControl.context;
  }

  set selectedLocation(location: Location | string) {
    if (location['title']) {
      const loc = location as Location;
      const tempId = this.dialogControl.context.id;
      this.dialogControl.context = loc;
      this.dialogControl.context.id = tempId;
    } else {
      this.dialogControl.context.title = location;
    }
  }

  onSelectedAccessTypeChanged(): void {
    this.setAccessTypes();
  }

  setAccessTypes(): void {
    const acessTypes = [{ id: CALENDAR_ACCESS_TYPE.GROUP, label: $localize`:@@appointment-configuration.access-control.group-based:Group based` }, { id: CALENDAR_ACCESS_TYPE.ROLE, label: $localize`:@@appointment-configuration.access-control.role-based:Role based` }];
    const calendar = this.dialogControl.context.calendar as Calendar;
    if (calendar.readerGroups?.length > 0 || calendar.writerGroups?.length > 0) {
      this.accessTypes = [acessTypes[0]];
    } else if (calendar.readerRoles?.length > 0 || calendar.writerRoles?.length > 0) {
      this.accessTypes = [acessTypes[1]];
    } else {
      this.accessTypes = acessTypes;
    }
  }

  onExportAttendeesToExcel(calendar : Calendar) {

    this.dialogService.open(AttendeesExportForm, {
      header: $localize`:@@appointment-configuration.form-exportAttendees: Export Attendees`,
      data: {
        calendar: calendar
      },
      height: '60%',
        modal: true,
        draggable: false,
        closable: true,
      focusOnShow: false,
      contentStyle: { display: 'flex' }
    }).onClose.subscribe((result) => {
      if (result) {
        // endDate + 1 da in Java erstaml ein Kalender objekt erstellt werden müsste...
        let endDatePlusOne = moment(result.endDate).format("MM-DD-YYYY");
        const url = `${this.apiURL}/file-api/calendars/${calendar.id}/attendance-list?from=${moment(result.startDate).format("MM-DD-YYYY")}&to=${endDatePlusOne}&createWorksheets=${result.createWorksheets}&access_token=${this.coreLibService.getJWTToken()}`;
        this.coreLibService.openLink(url, LinkOpenMode.External,null);
      }
    });
  }

}
